import React, { Component } from 'react'

import { selectCurrentLocationWithAddress } from '../../redux/modules/selectors'
import { Card } from '../common/Layout'
import { loadLocationStart } from '../../redux/modules/location'
import { callApi } from '../../api/api'
import { loginStart } from '../../redux/modules/user'
import { normalizeUserCreationError } from '../../util/errorUtils'
import { connect } from 'react-redux'

import { termsAndConditionsRoute } from '../../routes/routes'

function getQueryVariable(variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return false
}

const newLocationId = getQueryVariable('newLocationId')

class CompleteAccount extends Component {
  constructor(props) {
    super(props)
    this.state = {
      passwordShowing: false,
      error: false,
      loading: false,
      username: '',
      locationId: 0,
      password: '',
      submitLoading: false,
      successMessage: '',
      errorMessage: '',
      connectionId: null
    }

    this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.login = this.login.bind(this)
  }

  togglePasswordVisibility() {
    this.state.passwordShowing === true
      ? this.setState({ passwordShowing: false })
      : this.setState({ passwordShowing: true })

    let currentType = document.getElementById('password')
    currentType.type === 'password'
      ? (currentType.type = 'text')
      : (currentType.type = 'password')
  }

  componentDidMount() {
    const {
      match: {
        params: { token }
      }
    } = this.props
    callApi
      .get(`/api/v1/uaa/users/inviteCode/${token}`)
      .then(response => {
        this.setState({
          username: response.data.username,
          connectionId: response.data.connectionId
        })
        // Checks the URL if there is a new location ID, if not, it will just use the location ID from the token
        if (newLocationId) {
          this.setState({ locationId: newLocationId })
        } else {
          this.setState({ locationId: response.data.locationId })
        }

        this.props.loadLocationStart(this.state.locationId)
      })
      .catch(error => {
        if (error.response) {
          this.setState({
            errorMessage: normalizeUserCreationError(error.response),
            submitLoading: false
          })
        }
      })
  }

  login() {
    const loginPayload = {
      userName: this.state.username,
      password: this.state.password,
      connectionId: this.state.connectionId
    }
    this.props.loginStart(loginPayload)
  }

  handleSubmit(event) {
    event.preventDefault()
    this.login()
    this.setState({ submitLoading: true })
    const {
      match: {
        params: { token }
      }
    } = this.props
    const payload = {
      locationId: this.state.locationId,
      password: this.state.password
    }

    callApi
      .put(`/api/v1/uaa/users/inviteCode/${token}/confirm`, payload)
      .then(response => {
        this.setState({
          successMessage:
            "Success! You're password has been created. Logging you in..."
        })
        let _this = this
        setTimeout(() => {
          _this.login()
        }, 2500)
      })
      .catch(error => {
        if (error.response) {
          this.setState({
            errorMessage: normalizeUserCreationError(error.response),
            submitLoading: false
          })
        }
      })
  }

  handleChange(event) {
    this.setState({ password: event.target.value })
  }

  componentDidUpdate() {
    let { locationSearch } = this.props
    const {
      match: {
        params: { token }
      }
    } = this.props
    let foundLocations = locationSearch.locations.foundLocations

    if (foundLocations != null) {
      if (foundLocations.length === 1) {
        this.setState({
          locationId: foundLocations[0].id
        })
        window.location.href = `/complete-account/${token}/?newLocationId=${
          foundLocations[0].id
        }`
      }
    }
  }

  render() {
    return (
      <div className="complete-account-article">
        <Card>
          <div className="row center-xs">
            <h2>Complete Your Account</h2>
          </div>
          <div className="row segment center-xs">
            <div className="col-xs-12">
              <label style={{ textAlign: 'left' }}>Email:</label>
              <p className="segment-text" style={{ textAlign: 'left' }}>
                {this.state.username}
              </p>
              <label style={{ textAlign: 'left' }} htmlFor="pasword">
                Create a Password:
              </label>
              <div
                className="col end-xs"
                style={{ marginTop: '-38px', marginBottom: '10px' }}
              >
                <button
                  className="link"
                  style={{ fontSize: '15px' }}
                  onClick={this.togglePasswordVisibility}
                >
                  {this.state.passwordShowing
                    ? 'Hide Pasword'
                    : 'Show Password'}
                </button>
              </div>
              <form onSubmit={this.handleSubmit}>
                <input
                  type="password"
                  placeholder="password"
                  id="password"
                  className="completeAccountPassword _lr-hide"
                  onChange={this.handleChange}
                  required
                  autoFocus
                />
                <div className="checkbox">
                  <input type="checkbox" id="checkbox" required />
                  <label
                    htmlFor="checkbox"
                    style={{ textAlign: 'left', fontSize: '14px' }}
                  >
                    I agree to the{' '}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ fontSize: '16px' }}
                      href={termsAndConditionsRoute.path}
                    >
                      Terms and Conditions
                    </a>
                  </label>
                </div>
                <button type="submit" disabled={this.state.submitLoading}>
                  Submit
                </button>
              </form>
              <div className="success">{this.state.successMessage}</div>
              <div className="error">{this.state.errorMessage} </div>
              {this.state.errorMessage && (
                <div>
                  Already have an account?
                  <br />
                  Please try logging in <a href="/login">here</a>
                </div>
              )}{' '}
            </div>
          </div>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const location = selectCurrentLocationWithAddress(state)
  const locationSearch = state.locationSearch

  return {
    location,
    locationSearch
  }
}

const mapDispatchToProps = {
  loadLocationStart,
  loginStart
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompleteAccount)
